import { useConfigurationOptionsContext } from "app/providers/DoorOptionsProvider";
import EigenwijsOptionControls from "features/option-controls/eigenwijs-option-controls";
import { SelectionWrapper } from "../../widgets/configurator/door-options-controls/SelectionWrapper";
import { useLayoutNavigationFocus } from "widgets/configurator/door-options-controls/hooks/useLayoutNavigationFocus";
import { getLayoutBrowseGroup } from "entities/configurator/model/layoutMeta";
import { GroupedLayoutSelector } from "widgets/configurator/door-options-controls/components/GroupedLayoutSelector";
import { MobileDoorOptionsControlsList } from "./MobileDoorOptionsControlsList";
import { LayoutNavigationTransition } from "widgets/configurator/layout-navigation-transition";

interface DoorOptionsControlsProps {
  showMeasurementInputs?: boolean;
}

export const MobileDoorBasicLayoutsList = ({
  showMeasurementInputs = false,
}: DoorOptionsControlsProps) => {
  const { groupedLayouts, selectedDoor } = useConfigurationOptionsContext();
  const groupCode = groupedLayouts?.[0]?.code;
  const group = getLayoutBrowseGroup(groupCode);
  const { focusContent, onClickCapture } = useLayoutNavigationFocus(
    group,
    selectedDoor?.code,
  );
  const layoutViewKey = groupCode ?? "DoorOptionsControlsList";

  return (
    <LayoutNavigationTransition
      viewKey={layoutViewKey}
      focusContent={focusContent}
      className="gg-flex gg-w-full gg-flex-wrap gg-items-start gg-justify-start gg-gap-6 gg-pb-1"
      onClickCapture={onClickCapture}
    >
      {groupedLayouts ? (
        <GroupedLayoutSelector layouts={groupedLayouts} />
      ) : (
        <SelectionWrapper>
          <MobileDoorOptionsControlsList />

          <EigenwijsOptionControls
            showMeasurementInputs={showMeasurementInputs}
          />
        </SelectionWrapper>
      )}
    </LayoutNavigationTransition>
  );
};
